import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { IconButton, makeStyles } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons/';
import React, { useState } from 'react';
import ReactGA from 'react-ga';

import { useAuth } from '../../../../contexts/AuthContext/AuthContext';
import { api } from '../../../../core/api';
import { SearchReportTypes } from '../../../../core/api/search';
import { isTrialAccess } from '../../../../core/utils/access.utils';
import { QueryDto } from '../../../../generated/model/models';
import { useSnackbarMessage } from '../../../../hooks/useSnackbarMessage';
import { useErrorsDispatch } from '../../../../pages/FinancialData/shared/ErrorContext/ErrorContext';
import { ErrorContextActionTypes } from '../../../../pages/FinancialData/shared/ErrorContext/ErrorContext.types';

interface Props extends ICellRendererParams {
  data: QueryDto;
  reportType: SearchReportTypes;
}

const ReportDownloadCellRenderer: React.FC<Props> = ({ data, reportType }) => {
  const classes = useStyles();
  const reportExists = reportType === SearchReportTypes.RAW ? data?.rawData : data?.marketingReport;
  const dispatchErrors = useErrorsDispatch();
  const [snackbarReportText, setSnackbarReportText] = useState<string>('');
  const { user } = useAuth();
  const allowedToDownload = !isTrialAccess(user, data?.dataset);

  const handleClick = async () => {
    setSnackbarReportText(
      reportType === SearchReportTypes.MARKETING || reportType === SearchReportTypes.RAW
        ? 'companies:snackbarReportRawAndMarketingText'
        : 'companies:snackbarReportBothText',
    );
    try {
      ReactGA.event({ category: 'MY_SEARCHES', action: 'DOWNLOAD_ONE_CLICK', label: reportType });
      await api.search.downloadReport(reportType, data.id!);
    } catch (error) {
      dispatchErrors({
        type: ErrorContextActionTypes.SetError,
        payload: { error },
      });
    }
  };

  useSnackbarMessage(snackbarReportText !== '', snackbarReportText, {
    variant: 'info',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  });

  return reportExists && allowedToDownload ? (
    <IconButton size="small" onClick={handleClick}>
      <FileCopy className={classes.icon} />{' '}
    </IconButton>
  ) : null;
};

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.secondary.dark,
  },
}));

export default ReportDownloadCellRenderer;
